// extracted by mini-css-extract-plugin
export default {"root":"Auth_root__i0H4r","root_inner":"Auth_root_inner__gQFlH","logoWrapper":"Auth_logoWrapper__qMynj","auth":"Auth_auth__gj6hJ","footer_text":"Auth_footer_text__wOIU+"};